import api from "./api";

export const login = async (email_address: string, password: string): Promise<any> => {
    try {
        const response = await api.post("/auth/login", { email_address, password });

        if (response.data.status) {
            return response.data.data; // Return access_token if login is successful
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Login Failed");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const register = async (first_name: string, last_name: string, email_address: string, password: string): Promise<string> => {
    try {
        const response = await api.post("/auth/register", { first_name, last_name, email_address, password });

        if (!response.data.status) {
            throw new Error(response.data.message); // Throw error with message if registration fails
        }
        return response.data.message; // Return message if registration is successful
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Registration failed");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const verifyEmail = async (email_address: string) => {
    try {
        const response = await api.post("/auth/password/verify-email", { email_address });

        if (response.data.status) {
            return response.data; // Return access_token if login is successful
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Login Failed");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const verifyCode = async (email_address: string, verification_code: string) => {
    try {
        const response = await api.post("/auth/password/verify-email", { email_address, verification_code });

        if (response.data.status) {
            return response.data; // Return access_token if login is successful
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Login Failed");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const resetPassword = async (data: any) => {
    try {
        const response = await api.post("/auth/password/reset", data);

        if (response.data.status) {
            return response.data; // Return access_token if login is successful
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Login Failed");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getAdmin = async (): Promise<any> => {
    try {
        const token = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const response = await api.get("/auth/admin/me", {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data; // Return data if successful
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Authentication failure");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const logoutUser = (): void => {
    localStorage.removeItem("token");
};
